import { getDataAsync, postDataAsync, putDataAsync } from "../ZeosApiExecutor";
import {
  IScreeningDefinitionPublishRequest,
  IScreeningDefinitionSummary,
  IScreeningDefinitionUpsertRequest,
  IScreeningProviderCloneRequest,
  IScreeningReviewDecisionRequest,
  IScreeningReviewQueueItem,
} from "../contracts/ScreeningAdmin";
import { IScreeningAdmin } from "./interfaces/IScreeningAdmin";

const screeningAdminPrefix = "/Admin/Screening";

export const ScreeningAdmin: IScreeningAdmin = {
  getDefinitionsAsync: async (includeDrafts: boolean) => {
    return await getDataAsync<IScreeningDefinitionSummary[]>(
      `${screeningAdminPrefix}/Definitions?includeDrafts=${includeDrafts}`,
      ""
    );
  },
  upsertDefinitionAsync: async (request: IScreeningDefinitionUpsertRequest) => {
    return await postDataAsync<IScreeningDefinitionSummary>(
      `${screeningAdminPrefix}/Definitions`,
      request
    );
  },
  setDefinitionPublishedAsync: async (
    screeningDefinitionId: number,
    request: IScreeningDefinitionPublishRequest
  ) => {
    return await putDataAsync<IScreeningDefinitionSummary>(
      `${screeningAdminPrefix}/Definitions/${screeningDefinitionId}/Publish`,
      request
    );
  },
  cloneProviderAsync: async (request: IScreeningProviderCloneRequest) => {
    return await postDataAsync<boolean>(`${screeningAdminPrefix}/Providers/Clone`, request);
  },
  getReviewQueueAsync: async (status?: string) => {
    const query = status ? `?status=${encodeURIComponent(status)}` : "";
    return await getDataAsync<IScreeningReviewQueueItem[]>(
      `${screeningAdminPrefix}/ReviewQueue${query}`,
      ""
    );
  },
  approveReviewItemAsync: async (
    reviewQueueItemId: number,
    request: IScreeningReviewDecisionRequest
  ) => {
    return await postDataAsync<IScreeningReviewQueueItem>(
      `${screeningAdminPrefix}/ReviewQueue/${reviewQueueItemId}/Approve`,
      request
    );
  },
  denyReviewItemAsync: async (
    reviewQueueItemId: number,
    request: IScreeningReviewDecisionRequest
  ) => {
    return await postDataAsync<IScreeningReviewQueueItem>(
      `${screeningAdminPrefix}/ReviewQueue/${reviewQueueItemId}/Deny`,
      request
    );
  },
};
